<template>
  <div class="app-page rules-page">
    <div class="rules-header">
      <button class="back-btn" @click="$router.push('/game/lobby')">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
        返回大厅
      </button>
      <h2 class="page-title">游戏规则</h2>
    </div>

    <div class="rules-tabs">
      <button
        :class="['tab-btn', { active: activeTab === 'landlord' }]"
        @click="activeTab = 'landlord'"
      >斗地主</button>
      <button
        :class="['tab-btn', { active: activeTab === 'heiwu' }]"
        @click="activeTab = 'heiwu'"
      >挤黑五</button>
    </div>

    <!-- ====== 斗地主 ====== -->
    <div v-if="activeTab === 'landlord'" class="rules-content">
      <section class="rule-section">
        <h3>基本规则</h3>
        <ul>
          <li><strong>玩家人数：</strong>3人（2真人 + 1人机）</li>
          <li><strong>目标：</strong>地主一方需尽快出完所有手牌，农民一方需阻止地主并合作出完手牌</li>
          <li><strong>胜负：</strong>地主先出完则地主胜；任一农民先出完则农民方胜</li>
        </ul>
      </section>

      <section class="rule-section">
        <h3>发牌与叫地主</h3>
        <ul>
          <li>使用标准54张扑克牌（含大小王）</li>
          <li>每人发17张，留3张底牌</li>
          <li>本游戏采用<strong>随机地主</strong>模式，无需叫牌，系统随机指定地主</li>
          <li>地主获得3张底牌，共20张手牌</li>
        </ul>
      </section>

      <section class="rule-section">
        <h3>牌型大小</h3>
        <div class="card-types">
          <div class="type-item">
            <span class="type-name">单张</span>
            <span class="type-desc">任意一张牌，按点数比较：3 &lt; 4 &lt; 5 &lt; ... &lt; K &lt; A &lt; 2 &lt; 小王 &lt; 大王</span>
          </div>
          <div class="type-item">
            <span class="type-name">对子</span>
            <span class="type-desc">两张点数相同的牌</span>
          </div>
          <div class="type-item">
            <span class="type-name">三条</span>
            <span class="type-desc">三张点数相同的牌</span>
          </div>
          <div class="type-item">
            <span class="type-name">炸弹</span>
            <span class="type-desc">四张点数相同的牌，可管除火箭外的任何牌型</span>
          </div>
          <div class="type-item">
            <span class="type-name">火箭</span>
            <span class="type-desc">小王+大王，最大的牌型，可管一切</span>
          </div>
        </div>
      </section>

      <section class="rule-section">
        <h3>出牌规则</h3>
        <ul>
          <li>地主首先出牌，按逆时针顺序轮流</li>
          <li>下家需出相同牌型且点数更大的牌，或出炸弹/火箭</li>
          <li>若放弃出牌（"不要"），则轮到下家</li>
          <li>当其他三家都"不要"时，最后一手出牌者获得自由出牌权</li>
        </ul>
      </section>
    </div>

    <!-- ====== 挤黑五 ====== -->
    <div v-if="activeTab === 'heiwu'" class="rules-content">
      <section class="rule-section highlight">
        <h3>玩法概述</h3>
        <p>挤黑五是地方特色玩法，融合了升级的组队机制、跑得快的出牌逻辑以及独特的隐藏身份要素。黑桃5（♠5）是游戏的核心牌，玩法围绕其展开。</p>
      </section>

      <section class="rule-section">
        <h3>基本规则</h3>
        <ul>
          <li><strong>玩家人数：</strong>4人或5人</li>
          <li><strong>组队：</strong>每局随机选择一名<strong>庄家</strong>，持有黑桃5的玩家为庄家的<strong>隐藏队友</strong>（可就是庄家本人）</li>
          <li><strong>目标：</strong>庄家方两人尽快出完手牌</li>
          <li><strong>人数对应：</strong>4人局全真人，5人局可含人机</li>
        </ul>
      </section>

      <section class="rule-section">
        <h3>卡牌大小（重点）</h3>
        <div class="card-types">
          <div class="type-item">
            <span class="type-name">牌面大小</span>
            <span class="type-desc">4 &lt; 6 &lt; 7 &lt; 8 &lt; 9 &lt; 10 &lt; J &lt; Q &lt; K &lt; A &lt; 2 &lt; 3 &lt; 小王 &lt; 大王 &lt; <strong class="highlight-text">5</strong></span>
          </div>
          <div class="type-item">
            <span class="type-name special">特殊：5</span>
            <span class="type-desc"><strong>5是最大的牌</strong>，单张5只能被更大的5管住。注意：3和5之间的顺序是颠倒的（3变大，5最大）</span>
          </div>
          <div class="type-item">
            <span class="type-name special">花色优先级</span>
            <span class="type-desc">♠ &gt; ♥ &gt; ♣ &gt; ♦（仅当点数相同时比较花色）</span>
          </div>
        </div>
        <div class="rank-table-wrapper">
          <table class="rank-table">
            <thead>
              <tr><th>点数</th><th>4</th><th>6</th><th>7</th><th>8</th><th>9</th><th>10</th><th>J</th><th>Q</th><th>K</th><th>A</th><th>2</th><th>3</th><th>小王</th><th>大王</th><th>5</th></tr>
            </thead>
            <tbody>
              <tr><td>大小</td><td>1</td><td>2</td><td>3</td><td>4</td><td>5</td><td>6</td><td>7</td><td>8</td><td>9</td><td>10</td><td>11</td><td>12</td><td>13</td><td>14</td><td class="max-rank">15</td></tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="rule-section">
        <h3>可出牌型</h3>
        <div class="card-types">
          <div class="type-item">
            <span class="type-name">单张</span>
            <span class="type-desc">任意一张牌</span>
          </div>
          <div class="type-item">
            <span class="type-name">对子</span>
            <span class="type-desc">两张点数相同的牌（例如：♠6 ♥6）</span>
          </div>
          <div class="type-item">
            <span class="type-name">连对</span>
            <span class="type-desc"><strong>至少3个</strong>连续点数的对子（例如：♠4♥4 ♠6♥6 ♠7♥7）。注意中间不能跳点</span>
          </div>
          <div class="type-item">
            <span class="type-name bomb">炸弹</span>
            <span class="type-desc">三张点数相同的牌（例如：♠9 ♥9 ♣9），可管除王炸外的任何牌型</span>
          </div>
          <div class="type-item">
            <span class="type-name bomb">王炸</span>
            <span class="type-desc">四张点数相同的牌（小王×2+大王×2算4张相同），最大的牌型</span>
          </div>
          <div class="type-item">
            <span class="type-name note">注意</span>
            <span class="type-desc">两对王只是对子，不算炸弹</span>
          </div>
        </div>
      </section>

      <section class="rule-section">
        <h3>管牌规则</h3>
        <ul>
          <li><strong>同牌型比较：</strong>需出相同牌型且点数更大（连对需相同对数的更高连对）</li>
          <li><strong>炸弹管牌：</strong>炸弹可管除王炸外的任何非炸弹牌型</li>
          <li><strong>王炸管牌：</strong>王炸最大，可管一切</li>
          <li><strong>炸弹互管：</strong>三张炸弹之间，点数大的管点数小的</li>
          <li><strong>5的特殊性：</strong>5只能被5管——更大的单张5、带5的对子、带5的炸弹</li>
        </ul>
      </section>

      <section class="rule-section">
        <h3>出牌流程</h3>
        <ul>
          <li><strong>首轮出牌：</strong>持有♠5的玩家首先出牌（必须出包含♠5的牌型，但不必单独出♠5）</li>
          <li><strong>循环顺序：</strong>按顺时针方向轮流出牌</li>
          <li><strong>"不要"机制：</strong>若无法或不想管牌，可选择"不要"，轮到下家</li>
          <li><strong>自由出牌：</strong>当其他所有未出完牌的玩家都"不要"时，上一手出牌者获得自由出牌权，可出任意牌型</li>
          <li><strong>已出完玩家：</strong>跳过已出完手牌的玩家</li>
        </ul>
      </section>

      <section class="rule-section">
        <h3>组队与胜负判定</h3>
        <div class="team-info">
          <div class="team-card">
            <div class="team-label">庄家</div>
            <div class="team-desc">第一轮出牌时随机确定，身份公开</div>
          </div>
          <div class="team-card">
            <div class="team-label secret">黑桃5持有者</div>
            <div class="team-desc">庄家的隐藏队友，身份保密，由系统暗中标记</div>
          </div>
          <div class="team-card">
            <div class="team-label">对方</div>
            <div class="team-desc">庄家和黑桃5持有者以外的玩家</div>
          </div>
        </div>
        <div class="win-conditions">
          <h4>胜负结果</h4>
          <ul>
            <li><strong class="win-text">庄家方胜：</strong>庄家和黑桃5持有者两人都出完手牌，且对方阵营仍有玩家未出完</li>
            <li><strong class="draw-text">平局：</strong>黑桃5持有者第一个出完（打通关），但庄家最后一个出完</li>
            <li><strong class="lose-text">对方胜：</strong>以上两种情况以外的结果（庄家方有人未出完，或庄家最后一个出完且黑桃5不是第一个出完的）</li>
          </ul>
          <div class="special-case">
            <strong>特殊情况：</strong>若庄家就是黑桃5持有者（即庄家自己拿到了♠5），则庄家方只有一人。此时庄家需第一个出完手牌才算赢，否则对方胜。
          </div>
        </div>
      </section>

      <section class="rule-section">
        <h3>人机补位</h3>
        <ul>
          <li>至少需要你和1位好友组队即可开始</li>
          <li>剩余空位由系统人机自动补位</li>
          <li>人机行为由简单AI控制，会尝试出最小的牌或管上家的牌</li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const activeTab = ref('landlord')
</script>

<style scoped>
.rules-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 24px 16px;
}

.rules-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 14px;
  border: 1px solid var(--app-border-light);
  border-radius: var(--app-radius-full);
  background: var(--app-bg-elevated);
  color: var(--app-text-secondary);
  cursor: pointer;
  font-size: 0.85rem;
  transition: all 0.2s;
}
.back-btn:hover {
  border-color: var(--app-color-primary-light);
  color: var(--app-color-primary);
}

.page-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--app-text-primary);
  margin: 0;
}

.rules-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
}

.tab-btn {
  padding: 10px 28px;
  border: 1px solid var(--app-border-light);
  border-radius: var(--app-radius-full);
  background: var(--app-bg-elevated);
  color: var(--app-text-secondary);
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s;
}
.tab-btn.active {
  background: var(--app-color-primary);
  color: white;
  border-color: var(--app-color-primary);
}
.tab-btn:hover:not(.active) {
  border-color: var(--app-color-primary-light);
  color: var(--app-color-primary);
}

/* ── Rules Content ── */
.rules-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.rule-section {
  background: var(--app-bg-elevated);
  border-radius: var(--app-radius-lg);
  padding: 20px 24px;
  border: 1px solid var(--app-border-subtle);
}
.rule-section.highlight {
  border-color: var(--app-color-primary-light);
  background: var(--app-color-primary-soft);
}

.rule-section h3 {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--app-text-primary);
  margin: 0 0 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--app-border-light);
}

.rule-section h4 {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--app-text-primary);
  margin: 16px 0 8px;
}

.rule-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.rule-section ul li {
  position: relative;
  padding: 6px 0 6px 16px;
  color: var(--app-text-secondary);
  font-size: 0.9rem;
  line-height: 1.6;
}
.rule-section ul li::before {
  content: '•';
  position: absolute;
  left: 0;
  color: var(--app-color-primary);
}

.rule-section p {
  font-size: 0.9rem;
  color: var(--app-text-secondary);
  line-height: 1.7;
  margin: 0;
}

/* Card types */
.card-types {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.type-item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.type-name {
  flex-shrink: 0;
  min-width: 70px;
  padding: 2px 12px;
  border-radius: var(--app-radius-full);
  background: var(--app-color-primary-soft);
  color: var(--app-color-primary);
  font-size: 0.85rem;
  font-weight: 600;
  text-align: center;
}
.type-name.special {
  background: #fff3cd;
  color: #856404;
}
.type-name.bomb {
  background: #ffe0e0;
  color: #c0392b;
}
.type-name.note {
  background: var(--app-bg-soft);
  color: var(--app-text-muted);
}

.type-desc {
  flex: 1;
  font-size: 0.875rem;
  color: var(--app-text-secondary);
  line-height: 1.5;
}

.highlight-text {
  color: #e74c3c;
  font-size: 1.1rem;
}

/* Rank table */
.rank-table-wrapper {
  overflow-x: auto;
  margin-top: 12px;
}

.rank-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.rank-table th,
.rank-table td {
  padding: 8px 6px;
  text-align: center;
  border: 1px solid var(--app-border-light);
}

.rank-table th {
  background: var(--app-color-primary-soft);
  color: var(--app-color-primary);
  font-weight: 600;
}

.rank-table td {
  color: var(--app-text-primary);
}

.rank-table .max-rank {
  background: #ffe0e0;
  color: #c0392b;
  font-weight: 700;
}

/* Team info */
.team-info {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.team-card {
  flex: 1;
  min-width: 140px;
  padding: 14px;
  border-radius: var(--app-radius-md);
  border: 1px solid var(--app-border-light);
  background: var(--app-bg-soft);
}

.team-label {
  font-weight: 700;
  font-size: 0.9rem;
  color: var(--app-color-primary);
  margin-bottom: 4px;
}
.team-label.secret {
  color: #8e44ad;
}

.team-desc {
  font-size: 0.8rem;
  color: var(--app-text-muted);
  line-height: 1.4;
}

/* Win conditions */
.win-conditions {
  background: var(--app-bg-soft);
  border-radius: var(--app-radius-md);
  padding: 16px;
  margin-top: 8px;
}

.win-text { color: #27ae60; }
.draw-text { color: #f39c12; }
.lose-text { color: #e74c3c; }

.special-case {
  margin-top: 12px;
  padding: 12px;
  background: #fff3cd;
  border-radius: var(--app-radius-md);
  font-size: 0.85rem;
  color: #856404;
  line-height: 1.5;
}

@media (max-width: 600px) {
  .rule-section {
    padding: 16px;
  }
  .type-item {
    flex-direction: column;
    gap: 4px;
  }
  .type-name {
    align-self: flex-start;
  }
  .team-info {
    flex-direction: column;
  }
}
</style>
